import {
  COLOR_CALM,
  COLOR_CALM_LIGHT,
  COLOR_DANGER,
  COLOR_DANGER_LIGHT,
  COLOR_GRAY_300,
  COLOR_GRAY_600,
  COLOR_PRIMARY,
  COLOR_PRIMARY_LIGHT,
  COLOR_SUCCESS,
  COLOR_SUCCESS_LIGHT,
  COLOR_WARNING,
  COLOR_WARNING_LIGHT,
  COLOR_WHITE,
  SIZE_LG,
  SIZE_MD,
  SIZE_SM,
  SIZE_XL,
  SIZE_XS,
} from '../../config/constants';

export const CIRCLE_BASE_CLASS = 'circle';

export const CIRCLE_COLORS = [
  COLOR_WHITE,
  COLOR_PRIMARY,
  COLOR_PRIMARY_LIGHT,
  COLOR_SUCCESS,
  COLOR_SUCCESS_LIGHT,
  COLOR_DANGER,
  COLOR_DANGER_LIGHT,
  COLOR_CALM,
  COLOR_CALM_LIGHT,
  COLOR_GRAY_300,
  COLOR_GRAY_600,
  COLOR_WARNING,
  COLOR_WARNING_LIGHT,
];

export const CIRCLE_SIZES = [
  SIZE_XS,
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
  SIZE_XL,
];
